/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Integer 0-88, 'N/A', or null
 * @export
 * @interface GgFunctionScoreScore
 */
export interface GgFunctionScoreScore {
}

/**
 * Check if a given object implements the GgFunctionScoreScore interface.
 */
export function instanceOfGgFunctionScoreScore(value: object): value is GgFunctionScoreScore {
    return true;
}

export function GgFunctionScoreScoreFromJSON(json: any): GgFunctionScoreScore {
    return GgFunctionScoreScoreFromJSONTyped(json, false);
}

export function GgFunctionScoreScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): GgFunctionScoreScore {
    return json;
}

export function GgFunctionScoreScoreToJSON(json: any): GgFunctionScoreScore {
    return GgFunctionScoreScoreToJSONTyped(json, false);
}

export function GgFunctionScoreScoreToJSONTyped(value?: GgFunctionScoreScore | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

